import {TextField, TextFieldVariants} from '@mui/material';
import {useField} from 'formik';

export default function TextFieldWrapper({
    name,
    ...otherProps
}) {
    const[field, meta] = useField(name);

    const configTextField = {
        ...field,
        ...otherProps,
        fullWidth: true,
        variant: 'standard' as TextFieldVariants,
        error: false,
        helperText: '',
    };

    if(meta && meta.touched && meta.error) {
        configTextField.error = true;
        configTextField.helperText = meta.error;
    }

    return <TextField {...configTextField} />;
}
